(() => {
  const root = document.querySelector('.site-shell');
  if (!root || root.dataset.motionReady) return;
  root.dataset.motionReady = 'true';
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const hero = root.querySelector('.hero');
  if (!reduced?.matches) hero.classList.add('retreat-enter');

  // Navigation names are the existing section headings, not new marketing copy.
  const sections = ['included','your-weekend','venue','pricing','before-you-book'].map(id=>document.getElementById(id)).filter(Boolean);
  const nav = document.createElement('nav');
  nav.className = 'retreat-chapters'; nav.setAttribute('aria-label','Retreat sections');
  const links = sections.map(section=>{
    const link=document.createElement('a');link.href='#'+section.id;
    link.textContent=section.querySelector('h2').textContent;
    nav.append(link);return link;
  });
  hero.after(nav);
  let queued=false;
  const track=()=>{
    queued=false;
    let active=-1;
    sections.forEach((section,i)=>{if(section.getBoundingClientRect().top<=160)active=i;});
    links.forEach((link,i)=>{if(i===active)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
    const height=document.documentElement.scrollHeight-innerHeight;
    nav.style.setProperty('--read',String(height>0?Math.min(1,Math.max(0,scrollY/height)):0));
  };
  window.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(track);}},{passive:true});
  track();

  if ('IntersectionObserver' in window) {
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){if(!reduced?.matches)entry.target.classList.add('retreat-image-enter');observer.unobserve(entry.target);}
    }),{threshold:.15});
    root.querySelectorAll('.portrait-media,.included-visual,.weekend-photo,.scent-image,.property-gallery').forEach(el=>observer.observe(el));
  }

  const media=hero.querySelector('.hero-media');
  const fine=window.matchMedia?.('(hover: hover) and (pointer: fine)');
  media.addEventListener('pointermove',event=>{
    if(reduced?.matches || !fine?.matches)return;
    const r=media.getBoundingClientRect();
    media.style.setProperty('--mx',((event.clientX-r.left)/r.width-.5)*10+'px');
    media.style.setProperty('--my',((event.clientY-r.top)/r.height-.5)*10+'px');
  });
  const reset=()=>{media.style.setProperty('--mx','0px');media.style.setProperty('--my','0px');};
  media.addEventListener('pointerleave',reset);
  reduced?.addEventListener('change',()=>{reset();hero.classList.remove('retreat-enter');});

  // The full-size viewer follows the same gallery selection and never opens on its own.
  const deck=root.querySelector('#isyou-deck');
  const view=document.createElement('button');view.type='button';view.className='retreat-view-photo';view.textContent='View photo';
  deck.parentElement.append(view);
  const dialog=document.createElement('dialog');dialog.className='retreat-lightbox';dialog.setAttribute('aria-label','Retreat property photograph');
  const close=document.createElement('button');close.type='button';close.textContent='Close';close.className='retreat-lightbox-close';
  const img=document.createElement('img');const caption=document.createElement('p');caption.setAttribute('aria-live','polite');
  const controls=document.createElement('div');controls.className='retreat-lightbox-controls';
  const previous=document.createElement('button');previous.type='button';previous.textContent='←';previous.setAttribute('aria-label','Previous photo');
  const next=document.createElement('button');next.type='button';next.textContent='→';next.setAttribute('aria-label','Next photo');
  controls.append(previous,caption,next);dialog.append(close,img,controls);root.append(dialog);
  const sync=()=>{const source=deck.querySelector('[data-active] img');img.src=source.src;img.alt=source.alt;caption.textContent=source.alt;};
  const step=direction=>{root.querySelector(`.isyou-nav[data-dir="${direction}"]`).click();sync();};
  view.addEventListener('click',()=>{sync();dialog.showModal();close.focus();});
  close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>view.focus());
  previous.addEventListener('click',()=>step(-1));next.addEventListener('click',()=>step(1));
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();step(event.key==='ArrowRight'?1:-1);}});
})();

// Property atlas: a single stage and a numbered contact strip.
(() => {
  const venue=document.getElementById('venue');
  if(!venue || venue.dataset.atlasReady)return;
  const gallery=venue.querySelector('.property-gallery'),heading=venue.querySelector('.venue-copy h2');
  if(!gallery || !heading)return;
  venue.dataset.atlasReady='true';
  const header=document.createElement('div');header.className='retreat-journal-heading bo-container';header.append(heading);venue.prepend(header);
  const extra=venue.querySelector('.estate-strip');
  if(extra){[...extra.querySelectorAll('figure')].forEach(f=>gallery.append(f));extra.remove();}
  const figures=[...gallery.querySelectorAll('figure')];
  gallery.classList.add('property-atlas');gallery.tabIndex=0;gallery.setAttribute('role','region');gallery.setAttribute('aria-label','Retreat property photographs');
  const stage=document.createElement('div');stage.className='property-atlas-stage';figures.forEach(f=>stage.append(f));
  const index=document.createElement('div');index.className='property-atlas-index';index.setAttribute('role','group');index.setAttribute('aria-label','Choose a property photograph');
  const caption=document.createElement('div');caption.className='property-atlas-caption';caption.setAttribute('aria-live','polite');
  const count=document.createElement('span'),description=document.createElement('p');caption.append(count,description);
  const controls=document.createElement('div');controls.className='retreat-journal-controls';
  const previous=document.createElement('button');previous.type='button';previous.textContent='←';previous.setAttribute('aria-label','Previous property photograph');
  const next=document.createElement('button');next.type='button';next.textContent='→';next.setAttribute('aria-label','Next property photograph');controls.append(previous,next);caption.append(controls);
  let current=0;
  const buttons=figures.map((figure,i)=>{
    const original=figure.querySelector('img');
    const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`${i+1}: ${original.alt}`);
    const thumbnail=document.createElement('img');thumbnail.src=original.src;thumbnail.alt='';thumbnail.loading='lazy';
    const number=document.createElement('span');number.textContent=String(i+1).padStart(2,'0');number.setAttribute('aria-hidden','true');button.append(thumbnail,number);index.append(button);
    button.addEventListener('click',()=>show(i));return button;
  });
  const show=i=>{
    current=(i+figures.length)%figures.length;
    figures.forEach((figure,j)=>{figure.hidden=j!==current;});buttons.forEach((button,j)=>button.setAttribute('aria-pressed',String(j===current)));
    count.textContent=`${String(current+1).padStart(2,'0')} / ${String(figures.length).padStart(2,'0')}`;
    description.textContent=figures[current].querySelector('img').alt;
  };
  gallery.append(stage,index,caption);show(0);
  previous.addEventListener('click',()=>show(current-1));next.addEventListener('click',()=>show(current+1));
  gallery.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1));}});
  let start;
  stage.addEventListener('pointerdown',event=>{start={x:event.clientX,y:event.clientY};});
  stage.addEventListener('pointerup',event=>{if(!start)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1));});
  stage.addEventListener('pointercancel',()=>{start=null;});
})();
